import { useMemo } from 'react';
import { type IEmbedGoogleMaps } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function GoogleMaps ({
  googleMapsType,
  id,
}: IEmbedGoogleMaps) {
  const url = useMemo(() => {
    if (googleMapsType === 'mid') {
      return `https://www.google.com/maps/d/embed?mid=${id}`;
    }

    return `https://www.google.com/maps/embed?pb=${id}`;
  }, [googleMapsType, id]);

  return (
    <div className={styles.googleMapsEmbed__container}>
      <div className={styles.googleMapsEmbed__map}>
        <iframe
          allowFullScreen
          aria-hidden='false'
          className={styles.googleMapsEmbed__iframe}
          loading='lazy'
          referrerPolicy='no-referrer-when-downgrade'
          src={url}
          tabIndex={0}
          title=''
        />
      </div>
    </div>
  );
}
